import React, { useState } from "react"
import { useForm, Controller } from "react-hook-form"
import Button from "./button"

const FormBuyersEnquiry = ({ title, listing }) => {
  const { handleSubmit, control, reset } = useForm()
  const [successMessage, setSuccessMessage] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)

  const onSubmit = async data => {
    try {
      // Send the form data to your server or service.
      console.log("Form data:", data)

      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data).toString(),
      })

      if (response.ok) {
        reset() // Clear the form fields on successful submission.
        // Show the success message
        setSuccessMessage(
          "Thank you for your enquiry, somebody from the team will be in touch soon!"
        )
      } else {
        setErrorMessage("Form submission failed. Please try again later.")
      }
    } catch (error) {
      console.error("Error submitting the form:", error)
      setErrorMessage("Form submission failed. Please try again later.")
    }
  }

  return (
    <div className={"bg-blue"}>
      <div className={"max-w-4xl mx-auto px-4 sm:px-6"}>
        <div className={"py-12"}>
          <div className={"text-center mb-4"}>
            <h3 className={"text-3xl leading-none mb-4"}>
              {title ? title : "Enquire with Luxe Yachts"}
            </h3>
            {title ? (
              <p className={"text-navy text-lg mb-0"}>
                Please call us on{" "}
                <a href={"tel:+447876231207"} className={"font-bold"}>
                  +44 7876 231207
                </a>{" "}
                or email{" "}
                <a
                  href={"mailto:info@luxeyachts.co.uk"}
                  className={"font-bold"}
                >
                  info@luxeyachts.co.uk
                </a>
                ,
                <br />
                or fill out the enquiry form below and a member of our team will
                be in touch.
              </p>
            ) : (
              <p className={"text-navy text-lg mb-0"}>
                Looking for something special? Please call us on{" "}
                <a href={"tel:+447876231207"} className={"font-bold"}>
                  +44 7876 231207
                </a>{" "}
                or email{" "}
                <a
                  href={"mailto:info@luxeyachts.co.uk"}
                  className={"font-bold"}
                >
                  info@luxeyachts.co.uk
                </a>
                ,
                <br />
                or fill out the enquiry form below and tell us what you're
                looking for.
              </p>
            )}

            {successMessage && (
              <div className={"mt-4 bg-blue-600 p-2 mb-4 flex flex-row"}>
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={1.5}
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  className={"w-6 h-6 text-white stroke-current mr-1"}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p className={"text-white font-bold"}>{successMessage}</p>
              </div>
            )}

            {errorMessage && (
              <div className={"mt-4 bg-blue-600 p-2 mb-4 flex flex-row"}>
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={1.5}
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  className={"w-6 h-6 text-white stroke-current mr-1"}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                  />
                </svg>
                <p className={"text-white font-bold"}>{errorMessage}</p>
              </div>
            )}
          </div>

          <form
            name={"buyers-enquiry"}
            method={"POST"}
            onSubmit={handleSubmit(onSubmit)}
            netlify-honeypot="bot-field"
            data-netlify="true"
            action="#"
          >
            <Controller
              name="form-name"
              control={control}
              defaultValue={"buyers-enquiry"}
              render={({ field }) => (
                <input
                  {...field}
                  id="form-name"
                  type="hidden"
                  value={"buyers-enquiry"}
                />
              )}
            />

            <Controller
              name="listing"
              control={control}
              defaultValue={listing}
              render={({ field }) => (
                <input {...field} id="listing" type="hidden" value={listing} />
              )}
            />
            <div className="flex flex-col md:flex-row gap-4 lg:gap-8 mb-4">
              <div className="flex flex-col gap-4 w-full md:w-1/2">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-navy text-sm font-bold uppercase mb-1"
                  >
                    Your Name
                  </label>
                  <Controller
                    name="name"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="name"
                        type="text"
                        placeholder="Full name"
                        className={
                          "bg-white w-full p-3 border-2 border-blue-200 outline-none placeholder:text-gray-600 placeholder:font-light focus:border-navy transition duration-500 ease-in-out"
                        }
                      />
                    )}
                  />
                </div>
                <div>
                  <label
                    htmlFor="phone"
                    className="block text-navy text-sm font-bold uppercase mb-1"
                  >
                    Phone Number
                  </label>
                  <Controller
                    name="phone"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="phone"
                        type="text"
                        placeholder={"Enter your phone / mobile number"}
                        className={
                          "bg-white w-full p-3 border-2 border-blue-200 outline-none placeholder:text-gray-600 placeholder:font-light focus:border-navy transition duration-500 ease-in-out"
                        }
                      />
                    )}
                  />
                </div>
                <div>
                  <label
                    htmlFor="email"
                    className="block text-navy text-sm font-bold uppercase mb-1"
                  >
                    Email
                  </label>
                  <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="email"
                        type="email"
                        placeholder={"Enter your email address"}
                        className={
                          "bg-white w-full p-3 border-2 border-blue-200 outline-none placeholder:text-gray-600 placeholder:font-light focus:border-navy transition duration-500 ease-in-out"
                        }
                      />
                    )}
                  />
                </div>
              </div>
              <div className="w-full md:w-1/2 flex flex-col">
                <div className="flex flex-col flex-grow h-64 md:h-full">
                  <label
                    htmlFor="description"
                    className="block text-navy text-sm font-bold uppercase mb-1"
                  >
                    Your message
                  </label>
                  <Controller
                    name="description"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="description"
                        placeholder={"Please tell us how we can help you..."}
                        className={
                          "bg-white w-full h-full p-3 border-2 border-blue-200 outline-none placeholder:text-gray-600 placeholder:font-light focus:border-navy transition duration-500 ease-in-out"
                        }
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="text-right">
              <Button type={"submit"} variant={"blue"}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default FormBuyersEnquiry
